export default __webpack_public_path__ + "static/media/Footpad's Helm of the Tenth Court.18e8a8fe.jpg";